import React, { useEffect, useState } from 'react';
import api from '../api/api';

function Categories() {
    const [categories, setCategories] = useState([]);
    const [form, setForm] = useState({ name: '', imageUrl: '' });
    const [imageFile, setImageFile] = useState(null);
    const [editId, setEditId] = useState(null);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await api.get('/VendorCategory?limit=200');
            // Handle different response structures
            if (Array.isArray(res.data)) {
                setCategories(res.data);
            } else if (res.data.categories && Array.isArray(res.data.categories)) {
                setCategories(res.data.categories);
            } else {
                console.error('Unexpected response structure:', res.data);
                setCategories([]);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
            alert('فشل تحميل الفئات');
            setCategories([]);
        }
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        setImageFile(file);
        if (!file) return;
        const formData = new FormData();
        formData.append('Image', file);
        try {
            const res = await api.post('/Upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setForm(f => ({ ...f, imageUrl: res.data.url || res.data.imageUrl }));
        } catch {
            alert('فشل رفع الصورة');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let imageUrl = form.imageUrl;
            if (imageFile && !form.imageUrl) {
                const formData = new FormData();
                formData.append('Image', imageFile);
                const res = await api.post('/Upload', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                imageUrl = res.data.url || res.data.imageUrl;
            }
            if (editId) {
                await api.put(`/VendorCategory/${editId}`, { name: form.name, imageUrl });
            } else {
                await api.post('/VendorCategory', { name: form.name, imageUrl });
            }
            setForm({ name: '', imageUrl: '' });
            setImageFile(null);
            setEditId(null);
            fetchCategories();
        } catch {
            alert('فشل الحفظ');
        }
    };

    const handleEdit = (c) => {
        setForm({ name: c.name, imageUrl: c.imageUrl || '' });
        setEditId(c.id);
    };    const handleDelete = async (id) => {
        if (window.confirm('هل تريد حذف الفئة؟')) {
            try {
                const token = localStorage.getItem('token');
                await api.delete(`/VendorCategory/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                alert('تم حذف الفئة بنجاح');
                fetchCategories();
            } catch (err) {
                console.error('Delete vendor category error details:', err);
                console.error('Error response:', err?.response?.data);
                console.error('Error status:', err?.response?.status);
                
                let errorMessage = 'فشل حذف الفئة';
                if (err?.response?.data?.message) {
                    errorMessage += ': ' + err.response.data.message;
                } else if (err?.response?.status === 409) {
                    errorMessage = 'لا يمكن حذف الفئة لأنها تحتوي على متاجر مرتبطة بها';
                } else if (err?.response?.status === 401) {
                    errorMessage = 'غير مصرح لك بحذف هذه الفئة';
                } else if (err?.response?.status === 404) {
                    errorMessage = 'الفئة غير موجودة';
                } else if (err?.response?.status === 500) {
                    errorMessage = 'خطأ في الخادم. يرجى المحاولة مرة أخرى أو التواصل مع المطور';
                }
                
                alert(errorMessage);
            }
        }
    };

    const handleMoveUp = async (id) => {
        try {
            await api.patch(`/VendorCategory/${id}/move-up`);
            fetchCategories();
        } catch (err) {
            if (err?.response?.status !== 400) {
                alert('فشل تغيير الترتيب');
            }
        }
    };

    const handleMoveDown = async (id) => {
        try {
            await api.patch(`/VendorCategory/${id}/move-down`);
            fetchCategories();
        } catch (err) {
            if (err?.response?.status !== 400) {
                alert('فشل تغيير الترتيب');
            }
        }
    };

    // Helper to get full image URL
    const getImageUrl = (url) => {
        if (!url) return '';
        if (url.startsWith('http://') || url.startsWith('https://')) return url.replace(':5000', '');
        // Use the API base URL (without /api) for all relative paths
        const apiBase = (process.env.REACT_APP_API_URL || '').replace('/api', '');
        return apiBase + url;
    };

    return (
        <div>
            <h4 className="mb-3">إدارة الفئات</h4>

            <form className="mb-3" onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row">
                    <div className="col-md-4">
                        <input
                            className="form-control mb-2"
                            placeholder="اسم الفئة"
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                        />
                    </div>
                    <div className="col-md-4">
                        <input
                            type="file"
                            accept="image/*"
                            className="form-control mb-2"
                            onChange={handleImageChange}
                        />                        {form.imageUrl && (
                            <img src={getImageUrl(form.imageUrl)} alt="تصوير" style={{ maxWidth: 80, maxHeight: 80, marginTop: 8 }} />
                        )}
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-success">{editId ? 'تعديل' : 'إضافة'}</button>
                    </div>
                </div>
            </form>

            <table className="table table-bordered text-center">
                <thead>
                    <tr>
                        <th>الترتيب</th>
                        <th>الاسم</th>
                        <th>الصورة</th>
                        <th>الخيارات</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.map((c, index) => (
                        <tr key={c.id}>
                            <td>{c.displayOrder}</td>
                            <td>{c.name}</td>
                            <td>
                                {c.imageUrl && (
                                    <img src={getImageUrl(c.imageUrl)} alt="تصوير" style={{ maxWidth: 60, maxHeight: 60 }} />
                                )}
                            </td>
                            <td>
                                {index !== 0 && (
                                    <button className="btn btn-sm btn-secondary me-1" onClick={() => handleMoveUp(c.id)}>▲</button>
                                )}
                                {index !== categories.length - 1 && (
                                    <button className="btn btn-sm btn-secondary me-2" onClick={() => handleMoveDown(c.id)}>▼</button>
                                )}
                                <button className="btn btn-sm btn-primary me-2" onClick={() => handleEdit(c)}>تعديل</button>
                                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(c.id)}>حذف</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Categories;
